import React from "react";
import {
  Document,
  Page,
  View,
  StyleSheet,
  Text,
  Image,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";

import imgKkp from "../../../assets/images/logo_kkp.jpg";
import srcArial from "../../../assets/custom/font/arial/arial.ttf";
import srcArialBold from "../../../assets/custom/font/arial/ARIBL0.ttf";

try {
  Font.register({ family: "Arial", src: srcArial });
  Font.register({ family: "Arial-Bold", src: srcArialBold });
} catch (e) {
}

const styles = StyleSheet.create({
  page: {
    paddingTop: 24,
    paddingBottom: 30,
    paddingHorizontal: 30,
    fontFamily: "Helvetica", 
    fontSize: 9,
    color: "#1e293b",
  },

  // Header styles
  headerBox: {
    borderWidth: 1,
    borderColor: "#000000",
    marginBottom: 10,
  },
  headerTop: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000000",
  },
  headerLogoCol: {
    width: "22%",
    borderRightWidth: 1,
    borderColor: "#000000",
    alignItems: "center",
    justifyContent: "center",
    padding: 6,
    backgroundColor: "white",
  },
  headerLogoImg: {
    width: 60,
    height: 55,
    objectFit: "contain",
  },
  headerTextCol: {
    width: "78%",
    padding: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  headerTitleMain: {
    fontFamily: "Helvetica-Bold",
    fontSize: 14,
    textAlign: "center",
    color: "#000000",
  },
  headerTitleSub: {
    fontFamily: "Arial-Bold",
    fontSize: 12,
    textAlign: "center",
    marginTop: 2,
    color: "#000000",
  },
  headerBottom: {
    paddingVertical: 5,
    paddingHorizontal: 4,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8fafc",
  },
  headerDocType: {
    fontFamily: "Arial-Bold",
    fontSize: 12,
    textAlign: "center",
    color: "#000000",
  },
  headerDocSub: {
    fontFamily: "Helvetica-Bold",
    fontSize: 9.5,
    textAlign: "center",
    marginTop: 1,
    color: "#1e3a8a",
  },

  // Outer Wrapper Box for Application Data
  outerDataContainer: {
    borderWidth: 1,
    borderColor: "#000000",
    padding: 8,
    marginBottom: 10,
  },

  // Metadata Box Inside Outer Box
  metaCard: {
    borderWidth: 1,
    borderColor: "#e2e8f0",
    borderRadius: 3,
    padding: 6,
    backgroundColor: "#f8fafc",
    marginBottom: 8,
  },

  // Section Styles
  sectionHeader: {
    fontFamily: "Arial-Bold",
    fontSize: 10.5,
    color: "#0f172a",
    backgroundColor: "#e2e8f0",
    paddingVertical: 3,
    paddingHorizontal: 6,
    marginTop: 6,
    marginBottom: 4,
    borderLeftWidth: 3,
    borderLeftColor: "#1e3a8a",
  },

  // Table & Grid Layouts
  grid2Col: {
    flexDirection: "row",
    gap: 10,
  },
  gridCol: {
    flex: 1,
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 2.5,
    borderBottomWidth: 0.5,
    borderBottomColor: "#f1f5f9",
  },
  colKey: {
    width: "36%",
    color: "#334155",
    fontFamily: "Arial",
    fontSize: 10,
  },
  colSep: {
    width: "4%",
    textAlign: "center",
    color: "#64748b",
    fontSize: 10,
  },
  colVal: {
    width: "60%",
    color: "#0f172a",
    fontSize: 10,
  },
  colValBold: {
    width: "60%",
    color: "#0f172a",
    fontSize: 10,
    fontFamily: "Arial",
  },

  // Badge
  badge: {
    backgroundColor: "#dbeafe",
    color: "#1e40af",
    fontFamily: "Arial-Bold",
    fontSize: 8,
    paddingHorizontal: 5,
    paddingVertical: 1,
    borderRadius: 2,
    alignSelf: "flex-start",
  },

  statementBox: {
    marginTop: 8,
    padding: 6,
    backgroundColor: "#f1f5f9",
    borderLeftWidth: 2.5,
    borderLeftColor: "#64748b",
  },
  statementText: {
    fontSize: 7.5,
    color: "#475569",
    lineHeight: 1.3,
  },

  // Signatures
  signatureContainer: {
    marginTop: 14,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  signatureBox: {
    width: "45%",
    alignItems: "center",
  },
  signatureTitle: {
    fontSize: 8.5,
    color: "#334155",
    textAlign: "center",
  },
  signatureSpace: {
    height: 48,
    marginVertical: 4,
    alignItems: "center",
    justifyContent: "center",
  },
  signatureName: {
    fontFamily: "Arial-Bold",
    fontSize: 9,
    textDecoration: "underline",
    color: "#000000",
    marginTop: 2,
  },
  signatureSub: {
    fontSize: 8,
    color: "#64748b",
    marginTop: 1,
  },

  // Footer
  footer: {
    position: "absolute",
    bottom: 15,
    left: 30,
    right: 30,
    borderTopWidth: 1,
    borderTopColor: "#cbd5e1",
    paddingTop: 4,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  footerText: {
    fontSize: 7.5,
    color: "#64748b",
  },

    docTitleText: {
    fontFamily: "Arial-Bold",
    fontSize: 11,
    color: "#0f172a",
    marginBottom: 8,
  },
  docTableContainer: {
    width: "100%",
    marginTop: 4,
    borderWidth: 0.5,
    borderColor: "#cbd5e1",
  },
  docTableHeader: {
    flexDirection: "row",
    backgroundColor: "#e2e8f0", 
    paddingVertical: 8,
    paddingHorizontal: 4,
    alignItems: "center",
  },
  docTableHeaderCell: {
    color: "#020202",
    fontFamily: "Arial-Bold",
    fontSize: 8.5,
  },
  docTableRow: {
    flexDirection: "row",
    paddingVertical: 7,
    paddingHorizontal: 4,
    borderBottomWidth: 0.5,
    borderBottomColor: "#e2e8f0",
    alignItems: "center",
  },
  docRowEven: {
    backgroundColor: "#f8fafc",
  },
  docRowOdd: {
    backgroundColor: "#ffffff",
  },
  docTableCell: {
    fontSize: 8,
    color: "#1e293b",
    fontFamily: "Arial",
  },

  // Lebar Kolom Tabel Dokumen Lampiran
  colSeri: { width: "8%", textAlign: "center" },
  colKode: { width: "32%", paddingRight: 4 },
  colNomor: { width: "28%", paddingRight: 4 },
  colTgl: { width: "16%" },
  colNegara: { width: "16%" },
});

// Header
const Header = () => (
  <View style={styles.headerBox}>
    <View style={styles.headerTop}>
      <View style={styles.headerLogoCol}>
        <Image src={imgKkp} style={styles.headerLogoImg} />
      </View>
      <View style={styles.headerTextCol}>
        <Text style={styles.headerTitleMain}>
          KEMENTERIAN KELAUTAN DAN PERIKANAN
        </Text>
        <Text style={styles.headerTitleSub}>
          BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN 
        </Text>
      </View>
    </View>
    <View style={styles.headerBottom}>
      <Text style={styles.headerDocType}>FORMULIR PERMOHONAN SERTIFIKASI</Text>
      <Text style={styles.headerDocType}>
        CARA PENANGANAN IKAN YANG BAIK DI ATAS KAPAL (CPIB KAPAL)
      </Text>
    </View>
  </View>
);

//  Dummy Data Dokumen
const defaultDokumenList = [
  {
    seri: 1,
    kodeDokumen: "Nomor Induk Berusaha (NIB)",
    nomorDokumen: "8120008821604",
    tanggal: "2018-08-10",
    negara: "ID - Indonesia",
  },
  {
    seri: 2,
    kodeDokumen: "Surat Pernyataan kesediaan dilakukan inspeksi pengendalian mutu",
    nomorDokumen: "001/SSS-CPIB/VIII/26",
    tanggal: "2026-08-21",
    negara: "ID - Indonesia",
  },
  {
    seri: 3,
    kodeDokumen: "Sertifikat Kelaikan Kapal Perikanan (SKKP) - Laik Simpan",
    nomorDokumen: "B.96855/DJPT.3/PI.210/VIII/2026",
    tanggal: "2026-08-14",
    negara: "ID - Indonesia",
  },
  {
    seri: 4,
    kodeDokumen: "Panduan Mutu (kapal pembekuan)",
    nomorDokumen: "001",
    tanggal: "2026-08-18",
    negara: "ID - Indonesia",
  },
  {
    seri: 5,
    kodeDokumen: "Sertifikat Pelatihan Cara Penanganan Ikan Yang Baik",
    nomorDokumen: "457/DJPT.4/PI.310/712.31.02/V/2025",
    tanggal: "2025-05-19",
    negara: "ID - Indonesia",
  },
];

export const FormPermohonanKapal = ({ rowData, formData }) => {
  const data = formData || rowData;
  const listDokumen = data?.listDokumen || defaultDokumenList;
  const noPengajuan = data?.noAju || "AK15.0VIII202600112";

  return (
    <Document>
      {/* HALAMAN 1  */}
      <Page size="A4" style={styles.page}>
        <Header />

        <View style={styles.outerDataContainer}>

          {/* Info Card Pengajuan */}
          <View style={styles.metaCard}>
            <View style={styles.grid2Col}>
              <View style={styles.gridCol}>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "45%" }]}>
                    Nomor Pengajuan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colValBold, { color: "#1e3a8a", width: "50%" }]}>
                    {noPengajuan}
                  </Text>
                </View>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "45%" }]}>
                    Tanggal Pengajuan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colVal, { width: "50%" }]}>
                    {data?.tglAju || "TGL AJU KAPAL"}
                  </Text>
                </View>
              </View>

              <View style={styles.gridCol}>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "42%" }]}>
                    Jenis Permohonan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <View style={{ width: "54%" }}>
                    <Text style={styles.badge}>
                      {data?.jenisAju || "JENIS AJU KAPAL"}
                    </Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "42%" }]}>UPT</Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colVal, { width: "54%" }]}>
                    {data?.upt || "UPT PEMBINA"}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* A. DATA KAPAL & B. DATA PEMILIK */}
          <View style={styles.grid2Col}>

            {/* A: DATA KAPAL */}
            <View style={styles.gridCol}>
              <Text style={styles.sectionHeader}>A. DATA KAPAL</Text>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>1. Nama Kapal</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colValBold}>NAMA KAPAL</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>2. Nomor BKP</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>NOMOR BKP</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>3. NIB</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>NIB</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>4. Ukuran Kapal</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>UKURAN KAPAL</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>5. Jenis Kapal</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>JENIS KAPAL</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>6. Fasilitas</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>FASILITAS KAPAL</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>7. Nahkoda</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>NAHKODA</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>8. Jumlah ABK</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>JUMLAH ABK Orang</Text>
              </View>
            </View>

            {/* B: DATA PEMILIK */}
            <View style={styles.gridCol}>
              <Text style={styles.sectionHeader}>B. DATA PEMILIK</Text>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>1. Nama Pemilik</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colValBold}>NAMA PEMILIK</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>2. NPWP</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>NPWP</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>3. Alamat</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>ALAMAT</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>4. Telepon</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>TELEPON</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>5. Email</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>EMAIL</Text>
              </View>
            </View>
          </View>

          {/* C. DATA PENDARATAN & D. DATA PENANGGUNG JAWAB */}
          <View style={[styles.grid2Col, { marginTop: 4 }]}>

            {/* C: DATA PENDARATAN */}
            <View style={styles.gridCol}>
              <Text style={styles.sectionHeader}>C. DATA PENDARATAN</Text>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>1. Pelabuhan</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>PELABUHAN</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>2. UPT Pembina</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>UPT PEMBINA</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>3. Provinsi/Kota</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>provinsi / kota</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>4. Tgl Bongkar</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colValBold}>TGL BONGKAR</Text>
              </View>
            </View>

            {/* D: DATA PENANGGUNG JAWAB */}
            <View style={styles.gridCol}>
              <Text style={styles.sectionHeader}>D. DATA PENANGGUNG JAWAB</Text>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>1. Nama PJ</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colValBold}>NAMA PJ</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>2. Alamat PJ</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>ALAMAT PJ</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>3. Telpon PJ</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>TELEPON PJ</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.colKey}>4. Email PJ</Text>
                <Text style={styles.colSep}>:</Text>
                <Text style={styles.colVal}>EMAIL PJ</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.signatureContainer}>
          <View style={styles.signatureBox}></View>

          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Jakarta, date month year</Text>
            <Text style={styles.signatureTitle}>Pemohon / Penanggung Jawab</Text>
            <View style={styles.signatureSpace}></View>
            <Text style={styles.signatureName}>NAMA PJ</Text>
            <Text style={styles.signatureSub}>NAMA PEMILIK</Text>
          </View>
        </View>

        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Formulir Permohonan Sertifikasi CPIB Kapal — KKP RI (Dicetak pada {new Date().toLocaleDateString()})
          </Text>
          <Text style={styles.footerText}>Halaman 1 dari 2</Text>
        </View>
      </Page>

      {/*  HALAMAN 2  */}
      <Page size="A4" style={styles.page}>
        <Header />

        <View style={styles.outerDataContainer}>
          <View style={styles.metaCard}>
            <View style={styles.grid2Col}>
              <View style={styles.gridCol}>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "45%" }]}>
                    Nomor Pengajuan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colValBold, { color: "#1e3a8a", width: "50%" }]}>
                    {noPengajuan}
                  </Text>
                </View>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "45%" }]}>
                    Tanggal Pengajuan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colVal, { width: "50%" }]}>
                    {data?.tglAju || "TGL AJU KAPAL"}
                  </Text>
                </View>
              </View>

              <View style={styles.gridCol}>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "42%" }]}>
                    Jenis Permohonan
                  </Text>
                  <Text style={styles.colSep}>:</Text>
                  <View style={{ width: "54%" }}>
                    <Text style={styles.badge}>
                      {data?.jenisAju || "JENIS AJU KAPAL"}
                    </Text>
                  </View>
                </View>
                <View style={styles.tableRow}>
                  <Text style={[styles.colKey, { width: "42%" }]}>UPT</Text>
                  <Text style={styles.colSep}>:</Text>
                  <Text style={[styles.colVal, { width: "54%" }]}>
                    {data?.upt || "UPT PEMBINA"}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <Text style={styles.docTitleText}>
            Detil Lampiran Dokumen Permohonan Sertifikasi CPIB Kapal
          </Text>

          <View style={styles.docTableContainer}>
            <View style={styles.docTableHeader}>
              <Text style={[styles.docTableHeaderCell, styles.colSeri]}>Seri</Text>
              <Text style={[styles.docTableHeaderCell, styles.colKode]}>Kode Dokumen</Text>
              <Text style={[styles.docTableHeaderCell, styles.colNomor]}>Nomor Dokumen</Text>
              <Text style={[styles.docTableHeaderCell, styles.colTgl]}>Tanggal</Text>
              <Text style={[styles.docTableHeaderCell, styles.colNegara]}>Negara</Text>
            </View>

            {/* Rows Data Dokumen */}
            {listDokumen.map((item, index) => (
              <View
                key={index}
                style={[
                  styles.docTableRow,
                  index % 2 === 0 ? styles.docRowOdd : styles.docRowEven,
                ]}
              >
                <Text style={[styles.docTableCell, styles.colSeri]}>
                  {item.seri}
                </Text>
                <Text style={[styles.docTableCell, styles.colKode]}>
                  {item.kodeDokumen}
                </Text>
                <Text style={[styles.docTableCell, styles.colNomor]}>
                  {item.nomorDokumen}
                </Text>
                <Text style={[styles.docTableCell, styles.colTgl]}>
                  {item.tanggal}
                </Text>
                <Text style={[styles.docTableCell, styles.colNegara]}>
                  {item.negara}
                </Text>
              </View>
            ))}
          </View>
        </View>

        <View style={styles.footer} fixed>
          <Text style={styles.footerText}>
            Formulir Permohonan Sertifikasi CPIB Kapal — KKP RI (Dicetak pada {new Date().toLocaleDateString()})
          </Text>
          <Text style={styles.footerText}>Halaman 2 dari 2</Text>
        </View>
      </Page>
    </Document>
  );
};

export default FormPermohonanKapal;

// const FormPermohonanView = ({ rowData, formData }) => (
//   <PDFViewer width="100%" height="1000">
//     <FormPermohonanKapal rowData={rowData} formData={formData} />
//   </PDFViewer>
// );

// export default FormPermohonanView;